import React, { FC } from 'react';

import { Indicator } from '../../../../../../components';
import { TooltipItemProps } from './tooltip-item.types';
import { NavLink } from 'react-router-dom';
import { capitalize } from 'lodash';
import classNames from 'classnames';
import styles from './tooltip-item.module.scss';

const renderContent = ({
  icon,
  label,
  messagesCount,
}: Pick<TooltipItemProps, 'icon' | 'label' | 'messagesCount'>): JSX.Element => (
  <>
    <div className={styles.content}>
      {!!icon && <span className={styles.icon}>{icon}</span>}
      {!!label && <span className={styles.label}>{label === 'FAQ' ? 'FAQ' : capitalize(label)}</span>}
    </div>
    {messagesCount && typeof messagesCount === 'number' && messagesCount > 0 ? (
      <Indicator.Messages label={messagesCount} />
    ) : (
      <></>
    )}
  </>
);

/**
 * TooltipItem
 * @description Interactive tooltip list item.
 *
 * @author Sergii Goncharuk
 * @category Components
 * @param { TooltipItemProps } props - TooltipItemProps defined in the './menu-item.types.ts'.
 */
const TooltipItem: FC<TooltipItemProps> = ({ icon, label, onClick, disabled, linkTo, messagesCount, isHidden }) =>
  !isHidden ? (
    <div className={styles.wrapper}>
      {linkTo ? (
        <NavLink
          className={({ isActive }) => classNames(styles.item, isActive && styles.active)}
          type={'button'}
          to={linkTo}
          onClick={onClick}
        >
          {renderContent({ icon, label, messagesCount })}
        </NavLink>
      ) : (
        <button className={styles.item} type={'button'} disabled={disabled} onClick={onClick}>
          {renderContent({ icon, label, messagesCount })}
        </button>
      )}
    </div>
  ) : (
    <></>
  );

export { TooltipItem };
